// =====================================
//
//   OrderList Controller
//   Author: Wayne
//   createtime: 2016 / 08 / 30
//
// =====================================

window.InifECMobileApp.controller("OrderListController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'OrderService', 'ProductUtil',
	function($scope, $state, $timeout, $rootScope, $stateParams, OrderService, ProductUtil) {

        var init = function() {
            if(!$rootScope.useNativeLoginModal){
                $rootScope.useNativeLoginModal = $stateParams.useNativeLoginModal;    
            }
        }

        var getStepColorClass = function(order) {

            if(!order) {
                return;
            }

            if(order.isExtraFeeNeedPay) {
                return 'orange';
            }

            switch(order.orderstatus) {
                case 250:
                case 300:
                    return 'green';
                case 301:
                case 302:
                case 390:
                    return 'orange';
                case 0:
                case 201:
                case 202:
                case 303:
                case 800:
                case 801:
                case 803:
                case 806:
                    return 'red';
                default:
                    return 'blue';
            }
        }

        var getOrderStatus = function(order){
            var status = '';

            if(order.isExtraFeeNeedPay) {
                return '待付補收款';
            }

            switch(order.orderstatus){
                case 201:
                    status = '訂單取消';
                    break;
                case 202:
                    status = '等待稿件上傳';
                    break;
                case 301:
                case 302:
                case 390:
                    status = '稿件審核中';
                    break;
                case 303:
                    status = '審核不合格';
                    break;
                case 250:
                    status = '待付款';
                    break;
                case 300:
                    if(order.ispaid) {
                        status = '稿件審核中';
                    } else {
                        status = '待付款';
                    }
                    break;
                case 400:
                    if(order.productShoppingType == ProductUtil.ProductShoppingType.OLD_REVIEW_PAYMENT_PRINT
                        || order.productShoppingType == ProductUtil.ProductShoppingType.STOCK_PAYMENT
                    ) {
                        status = '付款成功';
                    } else {
                        status = '稿件審核中';
                    }
                    break;
                case 251:
                case 401:
                    status = '已通知付款';
                    break;
                case 501:
                case 502:
                    if(order.productShoppingType == ProductUtil.ProductShoppingType.STOCK_PAYMENT) {
                        status = '商品理貨中';
                    } else {
                        status = '商品製作中';    
                    }
                    break;
                case 600:
                    if(order.delivery == 0){
                        status = '可取貨';
                    }
                    break;
                case 601:
                    if(order.delivery == 1 || order.delivery == 2){
                        status = '待配送';
                    }
                    break;
                case 602:
                    if(order.delivery == 1 || order.delivery == 2){
                        status = '出貨中';
                    }
                    break;
                case 700:
                    status = '訂單完成';
                    break;
                case 800:
                    status = '退貨審查中';
                    break;
                case 801:
                    status = '退款處理中';
                    break;
                case 802:
                    status = '已完成退款';
                    break;
                case 803:
                    status = '退貨審查失敗';
                    break;
                case 804:
                    status = '稿件重印';
                    break;
                case 805:
                    status = '稿件重印';
                    break;
                case 806:
                    status = '部分退款處理中';
                    break;
                case 807:
                    status = '已完成部分退款';
                    break;
                default:
                    break;
            }

            return status;
        }

        // ------------------------------
        // 取得訂單物流查詢網址
        // ------------------------------
        var getOrderShipmentSearchUrl = function(order) {

            if(order.isGettingSearchUrl) {
                return;
            }

            order.isGettingSearchUrl = true;

            OrderService.getOrderShipmentSearchUrl(order.orderid, order.shippingCompanyType).then(function(url){

                if(url) {
                    order.isGettingSearchUrl = false;

                    var newWindow = window.open(url, "_blank");
                    newWindow.focus();
                }

            }, function(error) {
                console.log(error);
            })
        }

	    //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
            $scope.state = $state.current.name;
            if($scope.state == window.STATES.ORDER_LIST) {
                $state.go(window.STATES.ORDER_LIST_ALL);
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.state;
        $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;

        //==========================
        //  Methods
        //==========================
        $scope.getStepColorClass = getStepColorClass;
        $scope.getOrderStatus = getOrderStatus;
        $scope.getOrderShipmentSearchUrl = getOrderShipmentSearchUrl; // 取得訂單物流查詢網址

        //==========================
        //  Init
        //==========================
        init();
	}
]);